// extracted by mini-css-extract-plugin
module.exports = {"loading":"copy-content-trigger-standalone_loading__3fTSj","spinner":"copy-content-trigger-standalone_spinner__KVXN6"};